webpackJsonp([233373408885280],{

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LiveAction = function LiveAction() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "row width-container center-image" },
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/LXuGqoziq-U",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/yAwr5YdLpIk",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/_nJYg7G_C2g",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/JuGS3gY9muY",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/Uetnzbbjdbc",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/RIctgmUwJLs",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/ivezBCvhIzA",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/m3P5v4CbWvM",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/hD4pEY0FV_A",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/eLmSU3R5bI8",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/qKNf-1DSMvE",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/IjMqmfZjcm8",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/mzcqh5tcDfw",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/aON2gHRUeHs",
	          allowFullScreen: true
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", {
	          className: "embed-responsive-item",
	          src: "https://www.youtube.com/embed/7RIfFtadghc",
	          allowFullScreen: true
	        })
	      )
	    )
	  );
	};
	
	exports.default = LiveAction;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-animation-live-action-js-fbced9b577182da66e19.js